/**
 * CreateEvent - Strona tworzenia wydarzenia
 * wojskaspecjalne.pl
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { EventForm } from '../components/events';
import { RoleGuard } from '../components/RoleGuard';
import type { Event } from '../types/database.types';
import './CreateEvent.css';

export const CreateEvent: React.FC = () => {
  const navigate = useNavigate();

  console.log('[CreateEvent] Component mounted');

  const handleSuccess = (event: Event) => {
    console.log('[CreateEvent] Event created successfully:', event);
    alert('Wydarzenie zostało utworzone pomyślnie!');
    navigate(`/wydarzenia/${event.slug || event.id}`);
  };

  const handleCancel = () => {
    console.log('[CreateEvent] Cancel clicked, navigating to /wydarzenia');
    navigate('/wydarzenia');
  };

  console.log('[CreateEvent] Rendering with RoleGuard for permissions: events.create');

  return (
    <RoleGuard 
      roles={['admin', 'moderator']}
      permissions={['events.create']}
      fallback={
        <>
          <Helmet>
            <title>Brak dostępu - wojskaspecjalne.pl</title>
          </Helmet>
          <div className="premium-page-bg">
            <div className="create-event-page">
              <div className="create-event-page__header">
                <h1 className="create-event-page__title">Brak dostępu</h1>
                <p className="create-event-page__subtitle">
                  Nie masz uprawnień do tworzenia wydarzeń. Skontaktuj się z administratorem, jeśli uważasz, że to błąd.
                </p>
                <button 
                  onClick={() => navigate('/wydarzenia')} 
                  className="premium-button"
                  style={{ marginTop: '2rem' }}
                >
                  Wróć do wydarzeń
                </button>
              </div>
            </div>
          </div>
        </>
      }
    >
      <Helmet>
        <title>Dodaj Nowe Wydarzenie - wojskaspecjalne.pl</title>
        <meta name="description" content="Utwórz nowe wydarzenie na platformie wojskaspecjalne.pl" />
      </Helmet>

      <div className="premium-page-bg">
        <div className="create-event-page">
          <div className="create-event-page__header">
            <h1 className="create-event-page__title">Dodaj Nowe Wydarzenie</h1>
            <p className="create-event-page__subtitle">
              Wypełnij formularz poniżej, aby utworzyć nowe wydarzenie. Wszystkie pola oznaczone
              gwiazdką (*) są wymagane.
            </p>
          </div>

          <EventForm onSuccess={handleSuccess} onCancel={handleCancel} />
        </div>
      </div>
    </RoleGuard>
  );
};

